/**
 * Search Page Filter Enhancement
 * Forces all filters to append to search URL instead of going to archive pages
 * Only runs when NOT on the /shop/ page
 */

document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on the shop page or category page - if so, exit early
    const currentPath = window.location.pathname.toLowerCase();
    const isShopPage = currentPath === '/shop/' || currentPath === '/shop' || currentPath.startsWith('/shop/');
    
    // Check if we're on a search page (has 's' parameter)
    const urlParams = new URLSearchParams(window.location.search);
    const isSearchPage = urlParams.has('s') && urlParams.get('s').trim() !== '';
    
    // Additional check: if we're on a category page (not shop, not search), exit
    const isCategoryPage = !isShopPage && !isSearchPage;
    
    if (isShopPage) {
        return; // Exit early, don't run search filter overrides
    }
    
    if (isCategoryPage) {
        return; // Exit early, don't run search filter overrides on category pages
    }
    
    if (!isSearchPage) {
        return; // Exit early, don't run search filter overrides
    }
    
    // Get current search parameters
    const searchTerm = new URLSearchParams(window.location.search).get('s') || '';
    const searchType = 'products';
    
    // Main initialization
    initSearchFilters();
    
    /**
     * Initialize all search filter functionality
     */
    function initSearchFilters() {
      // 1. Override the filter form completely
      overrideFilterForm();
      
      // 2. Override the Apply button
      overrideApplyButton();
      
      // 3. Override the Clear button
      overrideClearButton();
      
      // 4. Override sorting and per page dropdowns
      overrideSortingDropdowns();
    }
    
    /**
     * Override the filter form to prevent default submission
     */
    function overrideFilterForm() {
      const filterForm = document.getElementById('product-filter-form');
      if (!filterForm) return;
      
      // Completely override the form submission
      filterForm.onsubmit = function(e) {
        e.preventDefault();
        
        // Build the search URL with all parameters
        const url = buildSearchUrl(filterForm);
        
        // Navigate to the URL
        window.location.href = url;
        return false;
      };
    }
    
    /**
     * Override the Apply button to use our custom submission
     */
    function overrideApplyButton() {
      const applyButton = document.querySelector('.product-filter__apply-btn button');
      if (!applyButton) return;
      
      // Override the click handler
      applyButton.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const filterForm = document.getElementById('product-filter-form');
        if (filterForm) {
          // Build the search URL with all parameters
          const url = buildSearchUrl(filterForm);
          
          // Navigate to the URL
          window.location.href = url;
        }
        return false;
      };
    }
    
    /**
     * Override the Clear button to go back to clean search
     */
    function overrideClearButton() {
      const clearButton = document.querySelector('.product-filter__clear-btn button');
      if (!clearButton) return;
      
      // Override the click handler
      clearButton.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Go back to clean search URL
        window.location.href = '/?s=' + encodeURIComponent(searchTerm) + '&search_type=products';
        return false;
      };
    }
    
    /**
     * Override sorting and per page dropdowns
     */
    function overrideSortingDropdowns() {
      // Sorting dropdown
      const sortingSelect = document.getElementById('search-sorting');
      if (sortingSelect) {
        sortingSelect.onchange = function() {
          const currentUrl = new URL(window.location.href);
          
          // Ensure search params
          currentUrl.searchParams.set('s', searchTerm);
          currentUrl.searchParams.set('search_type', searchType);
          
          // Update sorting
          if (this.value !== 'default') {
            currentUrl.searchParams.set('orderby', this.value);
          } else {
            currentUrl.searchParams.delete('orderby');
          }
          
          // Navigate
          window.location.href = currentUrl.toString();
        };
      }
      
      // Per page dropdown
      const perPageSelect = document.getElementById('search-per-page');
      if (perPageSelect) {
        perPageSelect.onchange = function() {
          const currentUrl = new URL(window.location.href);
          
          // Ensure search params
          currentUrl.searchParams.set('s', searchTerm);
          currentUrl.searchParams.set('search_type', searchType);
          
          // Update per page
          currentUrl.searchParams.set('per_page', this.value);
          
          // Navigate
          window.location.href = currentUrl.toString();
        };
      }
    }
    
    /**
     * Build a search URL with all filter parameters from the form
     */
    function buildSearchUrl(form) {
      // Start with base URL and search parameters
      const url = new URL(window.location.origin);
      url.searchParams.set('s', searchTerm);
      url.searchParams.set('search_type', searchType);
      
      // List of all possible filter inputs
      const filterInputs = [
        'product_cat_input',
        'price_range_input',
        'flavours_input',
        'dietary_input',
        'size_input',
        'colour_input',
        'availability_input',
        'shipping_class_input',
        'lead_time_input'
      ];
      
      // Add each filter parameter if it has a value
      filterInputs.forEach(inputId => {
        const input = form.querySelector('#' + inputId);
        if (input && input.value) {
          // Convert input ID to parameter name
          const paramName = inputIdToParamName(inputId);
          url.searchParams.set(paramName, input.value);
        }
      });
      
      // Add sorting if present
      const sortingSelect = document.getElementById('search-sorting');
      if (sortingSelect && sortingSelect.value !== 'default') {
        url.searchParams.set('orderby', sortingSelect.value);
      }
      
      // Add per page if present
      const perPageSelect = document.getElementById('search-per-page');
      if (perPageSelect) {
        url.searchParams.set('per_page', perPageSelect.value);
      }
      
      return url.toString();
    }
    
    /**
     * Convert input ID to parameter name
     */
    function inputIdToParamName(inputId) {
      // Simple conversion - remove _input suffix
      return inputId.replace('_input', '');
    }
  });